import { render, staticRenderFns } from "./WeekSchedule.vue?vue&type=template&id=4fb9c44d&scoped=true&"
import script from "./WeekSchedule.vue?vue&type=script&lang=js&"
export * from "./WeekSchedule.vue?vue&type=script&lang=js&"
import style0 from "./WeekSchedule.vue?vue&type=style&index=0&id=4fb9c44d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9c44d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VChip,VCol,VMenu,VRow,VSimpleTable,VSwitch,VTextField,VTimePicker})
